<template>
  <div id="paginaExcelMinistero">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Export Excel Ministero</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="2" md="3"">
                <h4>Consuntivo 2024</h4>
              </b-col>
              <b-col xl="6" md="6">
                <ejs-button id="downloadCalMinCons" @click.native="downloadCalMinConsXls(2024)">Scarica Excel Calendario Ministero Consuntivo</ejs-button>
              </b-col>
              <!-- <b-col xl="6" md="6" class="pt-1">
                <ejs-button id="downloadPersMinCons" @click.native="downloadPersMinConsXls(2024)">Scarica Excel Personale Ministero Consuntivo</ejs-button>
              </b-col> -->
            </b-row>
            <br/>
            
            <b-row class="pt-2">
              <b-col xl="2" md="3">
                <h4>Preventivo 2025</h4>
              </b-col>
              <b-col xl="6" md="6">
                  <ejs-button id="downloadCalMinPrev" @click.native="downloadCalMinPrevXls(2025)">Scarica Excel Calendario Ministero Preventivo</ejs-button>
                </b-col>
                <!-- <b-col xl="6" md="6" class="pt-1">
                   <ejs-button id="downloadPersMinPrev" @click.native="downloadPersMinPrevXls(2025)">Scarica Excel Personale Ministero Preventivo</ejs-button>
                </b-col> -->
                
            </b-row>
            <br/>
            
            <b-row class="pt-2">
              <b-col xl="2" md="3">
                <h4>Consuntivo 2025</h4>
              </b-col>
              <b-col xl="6" md="6">
                <ejs-button id="downloadCalMinCons" @click.native="downloadCalMinConsXls(2025)">Scarica Excel Calendario Ministero Consuntivo</ejs-button>
              </b-col>
              <!-- <b-col xl="6" md="6" class="pt-1"> -->
                <!-- <ejs-button id="downloadPersMinCons" @click.native="downloadPersMinConsXls(2025)">Scarica Excel Personale Ministero Consuntivo</ejs-button>
              </b-col> -->
            </b-row>
            <br>

            <b-row class="pt-2">
              <b-col xl="2" md="3">
                <h4>Preventivo 2026</h4>
              </b-col>

              <b-col xl="6" md="6">
                <ejs-button id="downloadCalMinPrev" @click.native="downloadCalMinPrevXls(2026)">Scarica Excel Calendario Ministero Preventivo</ejs-button>
              </b-col>
              <!-- <b-col xl="6" md="6" class="pt-1">
                   <!-- <ejs-button id="downloadPersMinPrev" @click.native="downloadPersMinPrevXls(2026)">Scarica Excel Personale Ministero Preventivo</ejs-button>
                   </b-col> -->
              
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  CardPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import {
  ButtonPlugin,
} from "@syncfusion/ej2-vue-buttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(ButtonPlugin)
// api
const apiSpettacoloUrl = "/demo/api/spettacolo";
const apiScritturaUrl = "/demo/api/scrittura";


export default Vue.extend({
  components: {},
  data() {
    return {
      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
        minDayInteger: 0,
        maxDayInteger: 100,
        stepDayInteger: 1,
      },
    };
  },
  created() {
    // log
    console.log("Pagina Export ministero Creata");
    // inizializzazione elenchi dal backend
    // chiamate API
  },

  methods: {
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },    
    downloadPersMinPrevXls(anno) {
      const persMinPrevUrl = apiScritturaUrl + "/export_pers_preventivo_xls"
      const datiDaInviare = {'anno': anno}
      useJwt.post(persMinPrevUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;
        const nomeFile = r.headers['content-disposition'].split('=').pop()
        //console.log(r.headers)
        link.setAttribute("download", nomeFile);
        //link.setAttribute("download", "export_pers_ministero_preventivo.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
    downloadPersMinConsXls(anno) {
      const persMinConsUrl = apiScritturaUrl + "/export_pers_consuntivo_xls"
      const datiDaInviare = {'anno': anno}
      useJwt.post(persMinConsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;
        const nomeFile = r.headers['content-disposition'].split('=').pop()

        link.setAttribute("download", nomeFile);

        //link.setAttribute("download", "export_pers_ministero_consuntivo.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
    downloadCalMinPrevXls(anno) {
      const persMinConsUrl = apiSpettacoloUrl + "/export_cal_min_prev_xls"
      const datiDaInviare = {'anno': anno}
      useJwt.post(persMinConsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;
        const nomeFile = r.headers['content-disposition'].split('=').pop()

        link.setAttribute("download", nomeFile);        
        //link.setAttribute("download", "export_calendario_ministero_preventivo.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
    downloadCalMinConsXls(anno) {
      const persMinConsUrl = apiSpettacoloUrl + "/export_cal_min_cons_xls"
      const datiDaInviare = {'anno': anno}
      useJwt.post(persMinConsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        const nomeFile = r.headers['content-disposition'].split('=').pop()
        console.log(nomeFile)
        link.href = url
        link.setAttribute("download", nomeFile);
        
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        console.log(r)
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
